<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.update_ads") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #404b3e">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="12"
            :identifier="
              [
                'mp4',
                'mov',
                'avi',
                'wmv',
                'flv',
                'mkv',
                'webm',
                'm4v',
              ].includes(data.image.path?.split('.').pop().toLowerCase())
                ? 'video'
                : 'image'
            "
            :preSelectedImage="data.image.path"
            :placeholder="$t('PLACEHOLDERS.advertisement_ar')"
            @selectImage="selectImage"
            required
            :acceptVideo="true"
          />

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.nameAr"
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.nameEn"
            required
          />

          <base-picker-input
            col="6"
            type="date"
            :disabledDate="disabledDate"
            :placeholder="$t('PLACEHOLDERS.start_date')"
            v-model.trim="data.publish_start_date"
          />

          <base-picker-input
            col="6"
            type="date"
            :disabledDate="disabledDate"
            :placeholder="$t('PLACEHOLDERS.end_date')"
            v-model.trim="data.publish_end_date"
          />

          <!-- Start:: Used In Select Input -->
          <base-select-input
            col="6"
            :optionsList="usedInOptions"
            :placeholder="$t('PLACEHOLDERS.advertisement_location')"
            v-model="data.used_in"
            required
          />
          <!-- End:: Used In Select Input -->

          <!-- Start:: Related to Ad Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="$t('PLACEHOLDERS.related_to_ad')"
              v-model="data.is_related_to_ad"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Related to Ad Switch Input -->

          <!-- Start:: Select Ad Input -->
          <base-select-input
            v-if="data.is_related_to_ad"
            col="6"
            :optionsList="adsOptions"
            :placeholder="$t('PLACEHOLDERS.select_ad')"
            v-model="data.selected_ad"
          />
          <!-- End:: Select Ad Input -->

          <!-- End:: Name Input -->

          <!-- Start:: Deactivate Switch Input -->
          <!-- <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div> -->
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";
import moment from "moment";

export default {
  name: "EditAds",

  components: { BaseImageUploadInput },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        image2: {
          path: null,
          file: null,
        },
        nameAr: null,
        nameEn: null,
        active: true,
        publish_start_date: null,
        publish_end_date: null,
        media: null,
        media_type: null,
        used_in: null,
        is_related_to_ad: false,
        selected_ad: null,
      },
      // End:: Data Collection To Send

      // Start:: Ads Options
      adsOptions: [],
      // End:: Ads Options

      // Start:: Used In Options
      usedInOptions: [
        {
          id: "landlord_app",
          name: this.$t ? this.$t("OPTIONS.landlord_app") : "تطبيق المؤجر",
          nameAr: "تطبيق المؤجر",
          nameEn: "Landlord App",
        },
        {
          id: "tenant_app",
          name: this.$t ? this.$t("OPTIONS.tenant_app") : "تطبيق المستأجر",
          nameAr: "تطبيق المستأجر",
          nameEn: "Tenant App",
        },
        {
          id: "all_apps",
          name: this.$t ? this.$t("OPTIONS.all_apps") : "جميع التطبيقات",
          nameAr: "جميع التطبيقات",
          nameEn: "All Apps",
        },
      ],
      // End:: Used In Options

      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  computed: {},

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    selectImage2(selectedImage) {
      this.data.image2 = selectedImage;
    },

    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: Get All Ads
    async getAllAds() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "ads",
          paras: {
            limit: 0,
            page: 0,
          },
        });
        this.adsOptions = res.data.data.data
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    },
    // End:: Get All Ads

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.nameAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameAr"));
        return;
      } else if (!this.data.nameEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameEn"));
        return;
      } else if (!this.data.used_in) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.advertisement_location"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("title[ar]", this.data.nameAr);

      REQUEST_DATA.append("title[en]", this.data.nameEn);

      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }
      if (this.data.publish_start_date) {
        REQUEST_DATA.append("start_date", this.data.publish_start_date);
      }
      if (this.data.publish_end_date) {
        REQUEST_DATA.append("end_date", this.data.publish_end_date);
      }
      REQUEST_DATA.append("used_in", this.data.used_in?.id);
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);
      if (this.data.is_related_to_ad) {
        REQUEST_DATA.append("ad_id", this.data.selected_ad?.id);
      }
      // REQUEST_DATA.append("__method", "PUT");
      REQUEST_DATA.append("_method", "PUT");
      // End:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `banners/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/ads/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // start all ads data
    async getAdsData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `banners/${this.$route.params.id}`,
        });
        this.data.image.path = res.data.data.banner.image;
        // this.data.image2.path = res.data.data.banner.media_en;
        this.data.nameAr = res.data.data.banner.title_ar;
        this.data.nameEn = res.data.data.banner.title_en;
        this.data.publish_start_date = res.data.data.banner.start_date;
        this.data.publish_end_date = res.data.data.banner.end_date;
        this.data.used_in = {
          id: res.data.data.banner.used_in,
          name:
            res.data.data.banner.used_in == "landlord_app"
              ? this.$t
                ? this.$t("OPTIONS.landlord_app")
                : "تطبيق المؤجر"
              : res.data.data.banner.used_in == "tenant_app"
              ? this.$t
                ? this.$t("OPTIONS.tenant_app")
                : "تطبيق المستأجر"
              : this.$t
              ? this.$t("OPTIONS.all_apps")
              : "جميع التطبيقات",
        };
        this.data.active = res.data.data.banner.is_active;
        // Set related ad data if available
        if (res.data.data.banner.type === "ad" && res.data.data.banner.ad) {
          this.data.is_related_to_ad = true;
          this.data.selected_ad = {
            id: res.data.data.banner.ad?.id,
            name: res.data.data.banner.ad?.name,
          };
        }
        // console.log(res.data.body.add_space)
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end all ads data
  },

  created() {
    // Start:: Fire Methods
    this.getAllAds();
    this.getAdsData();
    // End:: Fire Methods
  },
};
</script>

<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 20px;
}
</style>
